<div class="dialog-title-row" fxLayout="row" fxLayoutAlign="space-between start" style="align-items: flex-start;">
  <span *ngIf="layoutConf.isMobile" class="smaller-font" style="font-size: 12px;">{{data.title}}</span>
  <span *ngIf="!layoutConf.isMobile" class="smaller-font">{{data.title}}</span>
  <button mat-icon-button mat-sm-button class="close-button" (click)="close()" aria-label="Fechar">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="dialog-content">
  <mat-card class="p-0">
    <div fxLayout="row wrap" fxLayout.lt-sm="column" class="dialog-container">
      <div fxFlex="100" class="save-progress-slot">
        <mat-progress-bar mode="indeterminate" class="full-width save-progress-bar" [class.is-visible]="saveItem"></mat-progress-bar>
      </div>
      <form [formGroup]="doctoCForm" (ngSubmit)="submit()" (keydown.enter)="$event.preventDefault()">
        <div [fxLayout]="layoutConf?.isMobile ? 'row wrap' : 'column'" fxLayout.lt-sm="column" class="dialog-container desktop-static-stack">

          <div *ngIf="!layoutConf.isMobile" class="desktop-item-controls desktop-layout-lock">
            <div class="desktop-first-row">
              <div class="item-selector-block">
                <mat-form-field class="full-width desktop-select-field" appearance="outline">
                  <mat-label>Adicionar Item (Produto) ...</mat-label>
                  <mat-select [(value)]="produto" (selectionChange)="onSelectionChangeProduto($event)">
                    <mat-select-trigger>
                      <span class="desktop-product-trigger">{{ produto ? (produto?.codigo?.toString()?.padStart(6, '0') + '-' + produto?.descricao) : '' }}</span>
                    </mat-select-trigger>
                    <mat-option>
                      <ngx-mat-select-search [formControl]="doctoCForm?.controls['produtoSearch']!" placeholderLabel="Pesquisar Produto..."
                      noEntriesFoundLabel="Produto não encontrado" [searching]="searching">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let p of produtos; trackBy: trackByProdutoId" [value]="p">
                      <span class="produto-option-label">{{ p.codigo?.toString()?.padStart(6, '0') +"-" + p.descricao }}</span>
                      <button *ngIf="permiteCadastroInlineProduto" mat-icon-button type="button" class="idem-produto-btn"
                        (click)="idemProdutoInline(p, $event)" matTooltip="Idem (copiar produto)">
                        <mat-icon color="primary">file_copy</mat-icon>
                      </button>
                    </mat-option>
                    <mat-option *ngIf="permiteCadastroInlineProduto && produtos?.length === 0 && getProdutoSearchText().length > 0"
                      (click)="incluirProdutoInline()">
                      <mat-icon color="primary">add</mat-icon> Cadastrar "{{ getProdutoSearchText() }}"
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>

              <div class="item-add-actions">
                <button mat-raised-button [disabled]="produtoItemExists$?.value" class="mb-05" color="primary"
                  (click)="incluirDoctoI(newItem);$event.preventDefault();" [matTooltip]="'Adicionar Produto'">
                  <mat-icon>add</mat-icon>{{"ADD" | translate }} {{"FATURAMENTO_ITEM" | translate }}
                </button>
                <button mat-raised-button [disabled]="!produtoItemExists$?.value" class="mb-05" color="primary"
                  (click)="editExistingSelectedProdutoItem();$event.preventDefault();" [matTooltip]="'Editar Produto'">
                  <mat-icon>edit</mat-icon>{{"EDIT" | translate }} {{"FATURAMENTO_ITEM" | translate }}
                </button>
              </div>
            </div>

              <div class="desktop-barcode-block">
                <mat-form-field class="full-width desktop-barcode-field" appearance="outline">
                  <mat-label>Código de barras (Leitor USB/Teclado)</mat-label>
                  <input
                    #desktopBarcodeInputRef
                    matInput
                    [(ngModel)]="mobileBarcodeInput"
                    [ngModelOptions]="{standalone: true}"
                    placeholder="Digite/escaneie: COD ou CODxQTD e Enter"
                    (keydown.enter)="$event.preventDefault(); addItemByBarcodeMobile()"
                  >
                  <button
                    type="button"
                    mat-icon-button
                    matSuffix
                    [disabled]="mobileBarcodeSearching"
                    (click)="addItemByBarcodeMobile()"
                    matTooltip="Adicionar por código"
                    aria-label="Adicionar por código"
                  >
                    <mat-icon>add</mat-icon>
                  </button>
                </mat-form-field>
                <small *ngIf="produtoItemExists$ | async" class="form-error-msg barcode-exists-msg"> ** Produto já existe no Lançamento **</small>
              </div>
          </div>
  
          <div fxFlex="100" class="items-section desktop-layout-lock" [class.desktop-items-section]="!layoutConf?.isMobile">
              <div formArrayName="items">
                <div class="mobile-items-list" *ngIf="layoutConf?.isMobile">
                  <div class="mobile-fixed-controls">
                    <mat-form-field class="full-width mobile-product-field">
                      <mat-label>Adicionar Item (Produto) ...</mat-label>
                      <mat-select [(value)]="produto" (selectionChange)="onSelectionChangeProduto($event)">
                        <mat-option>
                          <ngx-mat-select-search [formControl]="doctoCForm?.controls['produtoSearch']!" placeholderLabel="Pesquisar Produto..."
                          noEntriesFoundLabel="Produto não encontrado" [searching]="searching">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let p of produtos; trackBy: trackByProdutoId" [value]="p">
                          <span class="produto-option-label">{{ p.codigo?.toString()?.padStart(6, '0') +"-" + p.descricao }}</span>
                          <button *ngIf="permiteCadastroInlineProduto" mat-icon-button type="button" class="idem-produto-btn"
                            (click)="idemProdutoInline(p, $event)" matTooltip="Idem (copiar produto)">
                            <mat-icon color="primary">file_copy</mat-icon>
                          </button>
                        </mat-option>
                        <mat-option *ngIf="permiteCadastroInlineProduto && produtos?.length === 0 && getProdutoSearchText().length > 0"
                          (click)="incluirProdutoInline()">
                          <mat-icon color="primary">add</mat-icon> Cadastrar "{{ getProdutoSearchText() }}"
                        </mat-option>
                      </mat-select>
                    </mat-form-field>

                    <div class="mobile-add-produto-row">
                      <div class="mobile-qty-stepper" role="group" aria-label="Quantidade">
                        <button type="button" mat-icon-button class="mobile-qty-btn" (click)="decMobileAddQty()"
                          [disabled]="mobileAddQty <= 1" aria-label="Diminuir quantidade">
                          <mat-icon>remove</mat-icon>
                        </button>
                        <mat-form-field appearance="outline" class="mobile-qty-field">
                          <input matInput type="number" inputmode="decimal" min="0" step="1" [(ngModel)]="mobileAddQty"
                            [ngModelOptions]="{standalone: true}" (focus)="$event.target.select()" aria-label="Quantidade a adicionar">
                        </mat-form-field>
                        <button type="button" mat-icon-button class="mobile-qty-btn" (click)="incMobileAddQty()"
                          aria-label="Aumentar quantidade">
                          <mat-icon>add</mat-icon>
                        </button>
                      </div>
                      <mat-form-field appearance="outline" class="mobile-valor-unit-field">
                        <mat-label>Valor Unit.</mat-label>
                        <input matInput type="text" inputmode="decimal"
                          [(ngModel)]="mobileAddValorUnit" [ngModelOptions]="{standalone: true}"
                          (focus)="$event.target.select()" currencyMask
                          [options]="{ prefix: '', align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }"
                          aria-label="Valor unitário">
                      </mat-form-field>
                    </div>
                    <button type="button" mat-flat-button color="primary" class="mobile-add-produto-btn"
                      [disabled]="!produto" (click)="addProductInlineMobile(); $event.preventDefault();"
                      aria-label="Adicionar produto ao lançamento">
                      <mat-icon>add_shopping_cart</mat-icon> Adicionar
                    </button>

                    <mat-form-field class="full-width mobile-product-field mobile-barcode-field" appearance="outline">
                      <mat-label>Código de barras (Leitor)</mat-label>
                      <input
                        #mobileBarcodeInputRef
                        matInput
                        [(ngModel)]="mobileBarcodeInput"
                        [ngModelOptions]="{standalone: true}"
                        [readonly]="layoutConf?.isMobile && !mobileManualBarcodeInput"
                        [attr.inputmode]="layoutConf?.isMobile ? (mobileManualBarcodeInput ? 'text' : 'none') : null"
                        placeholder="Bipe/digite: COD ou CODxQTD e Enter"
                        (focus)="layoutConf?.isMobile && !mobileManualBarcodeInput ? $event.target.blur() : null"
                        (keydown.enter)="$event.preventDefault(); addItemByBarcodeMobile()"
                      >
                      <button
                        type="button"
                        mat-icon-button
                        matSuffix
                        class="mobile-scan-trigger"
                        [disabled]="mobileBarcodeSearching"
                        (mousedown)="$event.preventDefault()"
                        (click)="onBarcodePrimaryAction()"
                        [matTooltip]="layoutConf?.isMobile ? 'Ler pela câmera' : 'Adicionar por código'"
                        [attr.aria-label]="layoutConf?.isMobile ? 'Abrir câmera para leitura' : 'Adicionar por código'"
                      >
                        <mat-icon>{{ layoutConf?.isMobile ? 'qr_code_scanner' : 'add' }}</mat-icon>
                      </button>
                    </mat-form-field>
                    <small *ngIf="produtoItemExists$ | async" class="form-error-msg barcode-exists-msg"> ** Produto já existe no Lançamento **</small>

                    <div *ngIf="mobileCameraScanning" class="mobile-scanner-panel">
                      <video #mobileBarcodeVideo playsinline autoplay muted class="mobile-scanner-video"></video>
                      <div class="mobile-scanner-actions">
                        <small>Aponte para o código de barras para leitura automática.</small>
                        <button type="button" mat-stroked-button color="warn" (click)="stopMobileBarcodeCamera()">
                          Fechar
                        </button>
                      </div>
                    </div>

                    <div class="mobile-add-row">
                      <button type="button" mat-stroked-button color="primary" class="mobile-manual-toggle" [class.is-active]="mobileManualBarcodeInput" (click)="toggleMobileManualBarcodeInput()" [disabled]="mobileBarcodeSearching">
                        <mat-icon>{{ mobileManualBarcodeInput ? 'keyboard_hide' : 'keyboard' }}</mat-icon>
                        {{ mobileManualBarcodeInput ? 'Fechar teclado' : 'Entrada manual' }}
                      </button>
                      <span fxFlex></span>
                    </div>

                    <div class="mobile-list-toolbar">
                      <mat-form-field appearance="outline" class="full-width mobile-search-field">
                        <mat-label>Buscar item</mat-label>
                        <input matInput [(ngModel)]="mobileItemSearch" [ngModelOptions]="{standalone: true}" placeholder="Produto, CFOP ou CST">
                      </mat-form-field>
                      <div class="mobile-list-toolbar-actions">
                        <mat-form-field appearance="outline" class="full-width mobile-sort-field">
                          <mat-label>Ordenar</mat-label>
                          <mat-select [(ngModel)]="mobileItemSortBy" [ngModelOptions]="{standalone: true}">
                            <mat-option value="inclusao">Inclusão (posição)</mat-option>
                            <mat-option value="issueDate">Inclusão (data)</mat-option>
                            <mat-option value="produto">Produto</mat-option>
                            <mat-option value="valorTotal">Valor Total</mat-option>
                            <mat-option value="qtde">Quantidade</mat-option>
                          </mat-select>
                          <button
                            type="button"
                            mat-icon-button
                            matSuffix
                            class="mobile-sort-direction-btn"
                            [matTooltip]="mobileItemSortDir === 'asc' ? 'Ordem crescente' : 'Ordem decrescente'"
                            (click)="$event.stopPropagation(); toggleMobileItemSortDir()"
                          >
                            <mat-icon>{{ mobileItemSortDir === 'asc' ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
                          </button>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>

                  <div class="mobile-items-cards-scroll" #mobileItemsScrollRef>
                  <mat-card class="mobile-item-card" *ngFor="let item of getMobileItemRows(); let displayIndex = index; trackBy: trackByMobileItemIndex">
                    <div class="mobile-item-header-row">
                      <div class="mobile-item-title">#{{ displayIndex + 1 }}</div>
                      <span fxFlex></span>
                      <button type="button" mat-icon-button color="primary" matTooltip="Editar item" (click)="editDoctoI(item.row.value, displayIndex, item.index)">
                        <mat-icon>edit</mat-icon>
                      </button>
                      <button type="button" mat-icon-button [matMenuTriggerFor]="itemMoreMenu" matTooltip="Mais opções">
                        <mat-icon>more_vert</mat-icon>
                      </button>
                      <mat-menu #itemMoreMenu="matMenu">
                        <button type="button" mat-menu-item (click)="editDoctoI(item.row.value, displayIndex, item.index)">
                          <mat-icon>edit</mat-icon>
                          <span>Editar Item</span>
                        </button>
                        <button type="button" mat-menu-item (click)="editDoctoIDI(item.row.value)">
                          <mat-icon>public</mat-icon>
                          <span>DI</span>
                        </button>
                        <button type="button" mat-menu-item (click)="openProdutoDetails(item.row?.value?.id?.fatProduto)">
                          <mat-icon>edit_square</mat-icon>
                          <span>Produto</span>
                        </button>
                        <button type="button" mat-menu-item (click)="openManutencaoPreco(item.row?.value?.id?.fatProduto)">
                          <mat-icon>price_change</mat-icon>
                          <span>Preço</span>
                        </button>
                        <button type="button" mat-menu-item (click)="deleteDoctoI(item.row.value)">
                          <mat-icon color="warn">delete</mat-icon>
                          <span>Excluir</span>
                        </button>
                      </mat-menu>
                    </div>

                    <div class="mobile-item-subtitle">
                      {{ item.row?.value?.id?.fatProduto?.codigo?.toString()?.padStart(6, '0') }} -
                      {{ item.row?.value?.id?.fatProduto?.descricao }}
                    </div>

                    <div class="mobile-item-grid">
                      <div><span>Qtde</span><strong>{{ item.row?.value?.qtde | number : '1.3-3' }}</strong></div>
                      <div><span>Unit.</span><strong class="money-value">{{ item.row?.value?.valorUnitario | number : '1.2-2' }}</strong></div>
                      <div><span>Total</span><strong class="money-value">{{ item.row?.value?.valorTotal | number : '1.2-2' }}</strong></div>
                      <div><span>Total Liq.</span><strong class="money-value strong-money-value">{{ item.row?.value?.valorTotalLiquido | number : '1.2-2' }}</strong></div>
                      <div><span>CFOP</span><strong>{{ item.row?.value?.tabCfopId ?? '-' }}</strong></div>
                      <div><span>CST</span><strong>{{ (item.row?.value?.icmsClasstrib ?? '') + ' - ' + codigoCst(item.row?.value?.icmsClasstrib ?? '') }}</strong></div>
                    </div>
                  </mat-card>
                  </div>
                </div>

                <ng-container *ngIf="!layoutConf?.isMobile">
                <div class="desktop-table-wrapper desktop-layout-lock">
                <ngx-datatable
                  class="material ml-0 mr-0 custom-datatable"
                  #ngxDatatable
                  [rows]="itemFormArray.controls"
                  [rowClass]="getDatatableRowClass"
                  [headerHeight]="60"
                  [footerHeight]="56"
                  [scrollbarH]="true"
                  [scrollbarV]="true"
                  [messages]="{emptyMessage:'Nenhum Item encontrado'}"
                  [limit]="pageSizeItem"
                  [rowHeight]="54"
                  [style.height.vh]="52"
                  [columnMode]="'standard'"
                  [externalSorting]="true"
                >
  
                  <ngx-datatable-column name="#"  [minWidth]="30" [maxWidth]="50">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      <div class="cell-top-align">
                        <strong>#{{ rowIndex+1 }}</strong>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  
                  <ngx-datatable-column name="Opções" [minWidth]="180" [maxWidth]="200">
                    <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
                      <div class="cell-top-align">
                          <button mat-icon-button mat-sm-button *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] && !layoutConf.isMobile" class="green-button"
                            [attr.data-control-index]="itemFormArray.controls.indexOf(row)"
                            matTooltip="Editar Item" (click)="isEditableDoctI[itemFormArray.controls.indexOf(row)]=!isEditableDoctI[itemFormArray.controls.indexOf(row)];">
                            <mat-icon>
                              edit
                            </mat-icon>
                          </button>
      
                          <button mat-icon-button mat-sm-button color="success" 
                            *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)] && !layoutConf.isMobile" 
                            matTooltip="Salvar Item" 
                            (click)="saveDoctoI(rowIndex)">
                            <mat-icon>save</mat-icon>
                          </button>
    
                        <button mat-icon-button mat-sm-button
                          *ngIf="layoutConf.isMobile"
                          class="green-button"
                          matTooltip="Editar/Detalhes do Item"
                          (click)="$event.preventDefault();editDoctoI(row.value, rowIndex, rowIndex)">
                          <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button mat-sm-button
                          *ngIf="!layoutConf.isMobile"
                          color="primary"
                          matTooltip="Editar/Detalhes do Item"
                          (click)="$event.preventDefault();editDoctoI(row.value, rowIndex, rowIndex)">
                            <mat-icon *ngIf="!layoutConf.isMobile">launch</mat-icon>
                            <mat-icon *ngIf="layoutConf.isMobile">edit</mat-icon>
                        </button>
    
                        <button mat-icon-button mat-sm-button mat-sm-button color="primary"
                          matTooltip="DI-Declaração de importação do Item" (click)="$event.preventDefault();editDoctoIDI(row.value)">
                            <mat-icon>public</mat-icon>
                        </button>

                        <button mat-icon-button mat-sm-button color="primary"
                          matTooltip="Editar Produto" (click)="$event.preventDefault();openProdutoDetails(row?.value?.id.fatProduto)">
                            <mat-icon>edit_square</mat-icon>
                        </button>

                        <button mat-icon-button mat-sm-button color="primary"
                          matTooltip="Manutenção Preço" (click)="$event.preventDefault();openManutencaoPreco(row?.value?.id.fatProduto)">
                            <mat-icon>price_change</mat-icon>
                        </button>
    
    
                        <button mat-icon-button mat-sm-button mat-sm-button color="warn"
                          matTooltip="Delete Item"  (click)="$event.preventDefault();deleteDoctoI(row.value)">
                          <mat-icon>delete</mat-icon>
                        </button>
                      </div>
                    </ng-template>
                   
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="Produto" [minWidth]="520" [maxWidth]="700">
                    <ng-template ngx-datatable-header-template>
                      <div class="item-sort-controls item-sort-controls-inline">
                        <strong>Ordenar por:</strong>
                        <button mat-stroked-button color="primary" type="button" class="item-sort-btn" (click)="sortByProduto('issueDate')">
                          Inclusão
                          <mat-icon inline style="margin-left:4px;">unfold_more</mat-icon>
                        </button>
                        <button mat-stroked-button color="primary" type="button" class="item-sort-btn" (click)="sortByProduto('codigo')">
                          Código
                          <mat-icon inline style="margin-left:4px;">unfold_more</mat-icon>
                        </button>
                        <button mat-stroked-button color="primary" type="button" class="item-sort-btn" (click)="sortByProduto('descricao')">
                          Descrição
                          <mat-icon inline style="margin-left:4px;">unfold_more</mat-icon>
                        </button>
                      </div>
                    </ng-template>
                    
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <ng-container>
                        {{ row?.value?.id.fatProduto.codigo?.toString().padStart(6, '0') + '-' +
                        utils.truncate(row?.value?.id.fatProduto.descricao,40) }}
                      </ng-container>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="Qtde" [minWidth]="80" [maxWidth]="100">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Quantidade">Qtde</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.qtde | number : '1.3-3' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <!-- formControlName="qtde" -->
                            <input tabIndex="1" matInput id="qtde" type="text" name="qtde" step="any"
                              [attr.data-row-index]="rowIndex"
                              [attr.data-control-index]="itemFormArray.controls.indexOf(row)"
                              [attr.data-produto-id]="row?.value?.id?.fatProduto?.id"
                              (focus)="$event.target.select()" appOnReturn [formGroupName]="rowIndex"
                              [formControl]="row.controls['qtde']" 
                              (change)="changeQtdeOrValorUnitario(row)"  currencyMask
                              [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="ValorUnit" [minWidth]="80" [maxWidth]="100">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Unitário">Unitário</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.valorUnitario | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="2" matInput id="valorUnitario" type="text" name="valorUnitario" step="any"
                              appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['valorUnitario']" 
                              (blur)="changeQtdeOrValorUnitario(row)"  currencyMask
                              [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="ValorTotal" [minWidth]="120" [maxWidth]="150">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Valor Total">Valor Total</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.valorTotal | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="3" matInput id="valorTotal" type="text" name="valorTotal" step="any"
                              appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['valorTotal']" 
                              (blur)="changeValorTotal(row)"  currencyMask
                              [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="(%) Desconto"[minWidth]="80" [maxWidth]="80">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="(%) Desconto">(%)Desconto</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.descPercUnitario | number : '1.3-3' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <!-- formControlName="valorUnitario" -->
                            <input tabIndex="3" matInput id="descPercUnitario" type="text" name="descPercUnitario"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['descPercUnitario']" 
                              (blur)="changeDescPercUnitario(row)" currencyMask
                              [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 3 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="Desconto" [minWidth]="80" [maxWidth]="100">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Desconto">Desconto</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.descValorUnitario | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="4" matInput id="descValorUnitario" type="text" name="descValorUnitario"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['descValorUnitario']"
                              (blur)="changedescValorUnitario(row)"  
                              currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="valorUnitarioLiquido" [minWidth]="80" [maxWidth]="100">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Unitário.Líq.">Unitário.Líq.</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.valorUnitarioLiquido | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <!-- (click)="saveDoctoI(rowIndex)" -->
                            <input tabIndex="5" matInput id="valorUnitarioLiquido" type="text" name="valorUnitarioLiquido" step="any"
                              (keydown.enter)="enterPressedOnValorUnLiq()" (focus)="$event.target.select()"
                              [formGroupName]="rowIndex" [formControl]="row.controls['valorUnitarioLiquido']"
                               (blur)="saveDoctoI(rowIndex)" currencyMask
                              [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="Vl.Total Líq" [minWidth]="120" [maxWidth]="150"> 
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Vl.Total Líq">Vl.Total Líq</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container>
                          {{ row?.value?.valorTotalLiquido | number : '1.2-2' }}
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="CFOP" [minWidth]="80" [maxWidth]="80">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="CFOP">CFOP</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.tabCfopId??'' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="6" [imask]="maskCfop" matInput id="tabCfopId" type="text" name="tabCfopId"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['tabCfopId']" class="align-right">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="CST" [minWidth]="130" [maxWidth]="130">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="CST">CST</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] || !classTribIcmsInformavel">
                          <span [title]="!classTribIcmsInformavel
                              ? 'CST definido pela transação/produto (diretiva 127). Para digitar no item, use a opção 9-Informado.'
                              : descClassTribIcms(row?.value?.icmsClasstrib??'')">
                            {{ (row?.value?.icmsClasstrib??'') + ' - ' + codigoCst(row?.value?.icmsClasstrib??'') }}
                          </span>
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)] && classTribIcmsInformavel">
                          <mat-form-field class="full-width">
                            <mat-select tabIndex="7" [formGroupName]="rowIndex"
                              [formControl]="row.controls['icmsClasstrib']" appOnReturn>
                              <mat-option [value]="null">(padrão do produto)</mat-option>
                              <mat-option *ngFor="let ct of classTribIcms" [value]="ct?.id"
                                [title]="ct?.descricao">
                                {{ ct?.id + ' - ' + (ct?.codigoricms ?? '') + ' - ' + (ct?.descricao ?? '') }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="ibsCbsClasstrib" [minWidth]="150" [maxWidth]="150">
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Classificação Tributária (IBS/CBS)">CST IBS/CBS</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] || !classTribIbsCbsInformavel">
                          <span [title]="!classTribIbsCbsInformavel
                              ? 'Classificação definida pela transação/produto (diretiva 182). Para digitar no item, use a opção 9-Informado.'
                              : descClassTribIbsCbs(row?.value?.ibsCbsClasstrib??'')">
                            {{ row?.value?.ibsCbsClasstrib??'' }}
                          </span>
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)] && classTribIbsCbsInformavel">
                          <mat-form-field class="full-width">
                            <mat-select tabIndex="7" [formGroupName]="rowIndex"
                              [formControl]="row.controls['ibsCbsClasstrib']" appOnReturn>
                              <mat-option [value]="null">(padrão do produto)</mat-option>
                              <mat-option *ngFor="let ct of classTribIbsCbs" [value]="ct?.id"
                                [title]="ct?.descricao">
                                {{ ct?.id + ' - ' + (ct?.descricao ?? '') }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="icmsDigitacaomanual" [flexGrow]="1" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <mat-icon title="Fixar ICMS?" aria-label="Fixar ICMS?">check</mat-icon>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.icmsDigitacaomanual ? 'Sim' : 'Não' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-checkbox [formGroupName]="rowIndex" [formControl]="row.controls['icmsDigitacaomanual']" (change)="selectIcmsBaseCalculo($event)">
                            Fixar ICMS?
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                 
                  <ngx-datatable-column name="icmsBasecalculo" [flexGrow]="1" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Base de Cálculo do ICMS">ICMS BC</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] && !row?.value?.icmsDigitacaomanual">
                          {{ row?.value?.icmsBasecalculo | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)] && row?.value?.icmsDigitacaomanual">
                          <mat-form-field class="full-width">
                            <input tabIndex="7" matInput id="icmsBasecalculo" type="text" name="icmsBasecalculo"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['icmsBasecalculo']" 
                              (blur)="changeIcmsPercentual(row)" 
                              currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="icmsPerc" [flexGrow]="1.5" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="ICMS %">ICMS %</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] && !row?.value?.icmsDigitacaomanual">
                          {{ row?.value?.icmsPerc | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)] && row?.value?.icmsDigitacaomanual">
                          <mat-form-field class="full-width">
                             <input tabIndex="8" matInput id="icmsPerc" type="text" name="icmsPerc"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['icmsPerc']"
                              (blur)="changeIcmsPercentual(row)" 
                              currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  
  
                  <ngx-datatable-column name="icmsValor" [flexGrow]="2" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Valor ICMS">ICMS Valor</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]  && row?.value?.icmsDigitacaomanual">
                          {{ row?.value?.icmsValor | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="9" matInput id="icmsValor" type="text" name="icmsValor" step="any"
                              (keydown.enter)="enterPressedOnIcmsValor()" (focus)="$event.target.select()"
                              [formGroupName]="rowIndex" [formControl]="row.controls['icmsValor']"
                              currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
  
                  <ngx-datatable-column name="ipiDigitacaomanual" [flexGrow]="1" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <mat-icon title="Fixar IPI?" aria-label="Fixar IPI?">check</mat-icon>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.ipiDigitacaomanual ? 'Sim' : 'Não' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-checkbox [formGroupName]="rowIndex" [formControl]="row.controls['ipiDigitacaomanual']" (change)="selectIpiValor($event)">
                            Fixar IPI?
                          </mat-checkbox>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>
                  <!--ALIQUOTA DE IPI VEM DO CADASTRO DE PRODUTO  -->
                  <!-- <ngx-datatable-column name="ipiPercentual" [flexGrow]="1" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="IPI %">IPI %</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)] && row?.value?.ipiDigitacaomanual">
                          {{ row?.value?.ipisPercentual | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="9" matInput id="ipiPercentual" type="text" name="ipiPercentual"
                              step="any" appOnReturn (focus)="$event.target.select()" [formGroupName]="rowIndex"
                              [formControl]="row.controls['ipiPercentual']" placeholder="% IPI"
                              (blur)="changeIpiPercentual(row)" mask="separator.2" decimalMarker=","
                              thousandSeparator="." separatorLimit="100000000">    
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column> -->
  
                  <ngx-datatable-column name="ipiValor" [flexGrow]="2" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Valor IPI">IPI Valor</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        <ng-container *ngIf="!isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          {{ row?.value?.ipiValor | number : '1.2-2' }}
                        </ng-container>
                        <ng-container *ngIf="isEditableDoctI[itemFormArray.controls.indexOf(row)]">
                          <mat-form-field class="full-width">
                            <input tabIndex="10" matInput id="ipiValor" type="text" name="ipiValor" step="any"
                              (keydown.enter)="enterPressedOnIcmsValor()" (focus)="$event.target.select()"
                              [formGroupName]="rowIndex" [formControl]="row.controls['ipiValor']"
                              currencyMask [options]="{ prefix: '',  align: 'right', thousands: '.', allowNegative: false, decimal: ',', precision: 2 }">
                          </mat-form-field>
                        </ng-container>
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="pisBasecalculo" [flexGrow]="1.5" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Base de Cálculo do PIS">PIS BC</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.pisBasecalculo | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="pisPerc" [flexGrow]="1.2" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Percentual do PIS">PIS %</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.pisPerc | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="pisValor" [flexGrow]="1.5" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Valor do PIS">PIS Valor</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.pisValor | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="cofinsBasecalculo" [flexGrow]="1.5" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Base de Cálculo do COFINS">COFINS BC</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.cofinsBasecalculo | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="cofinsPerc" [flexGrow]="1.2" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Percentual do COFINS">COFINS %</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.cofinsPerc | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-column name="cofinsValor" [flexGrow]="1.5" >
                    <ng-template ngx-datatable-header-template let-column="column">
                      <div style="text-align:right">
                        <span title="Valor do COFINS">COFINS Valor</span>
                      </div>
                    </ng-template>
                    <ng-template let-rowIndex="rowIndex" let-value="value" let-row="row" ngx-datatable-cell-template>
                      <div style="text-align:right">
                        {{ row?.value?.cofinsValor | number : '1.2-2' }}
                      </div>
                    </ng-template>
                  </ngx-datatable-column>

                  <ngx-datatable-footer class="custom-footer">
                    <ng-template ngx-datatable-footer-template>
                      <div class="paginator-container">
                        <mat-paginator
                          #paginatorItem
                          [length]="lengthItem"
                          [showFirstLastButtons]="true"
                          [pageSize]="pageSizeItem"
                          [pageSizeOptions]="pageSizeOptionsItem"
                          (page)="pageEventItem = setPageSizeOptionsItem($event)"
                        >
                        </mat-paginator>
                      </div>
                    </ng-template>
                  </ngx-datatable-footer>
  
                </ngx-datatable>
                </div>
                </ng-container>
              </div>
          </div>
        </div>
      </form>
    </div>
  </mat-card>
</div>

<mat-dialog-actions *ngIf="!layoutConf?.isMobile">
  <div fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center">
    <!-- Save Button -->
    <button mat-raised-button [matTooltip]="'Salvar Lançamento'" color="primary"
      (click)="save();$event.preventDefault();">
      <mat-icon>save</mat-icon> {{"SAVE" | translate }}
    </button>

    <!-- Close Button -->
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{"CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>